import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CheckBoxList from "../../unit/forms/CheckBoxList";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomCounteredFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [showCreditBureau, setShowCreditBureau] = React.useState(false);
  const [amountOffered, setAmountOffered] = React.useState("");
  const [showFico, setShowFico] = React.useState(false);
  const [outsideSourceSelected, setOutsideSourceSelected] = React.useState<
    string[]
  >([]);
  const [creditValSlected, setCreditValSlected] = React.useState<string[]>([]);
  const [rateOffered, setRateOffered] = React.useState(record?.rate || "");
  const [termOffered, setTermOffered] = React.useState(
    record?.termSubmit || ""
  );
  const refresh = useRefresh();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const formatRate = (num: any) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };

  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i],
      });
    }
  }
  const defautTermsList = [];
  defautTermsList.push({ label: "Select", value: "" });
  if (record.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: record.termsData[i],
      });
    }
  }

  const defautPaymentFreqList = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const reasons_adverse_action_list: { label: string; value: string }[] = [];
  if (record.adverseData) {
    record.adverseData.map((adverse: any) => {
      reasons_adverse_action_list.push({
        label: adverse.name,
        value: adverse.id,
      });
    });
  }
  const reasons_adverse_action_selected: { label: string; value: string }[] =
    [];

  const outside_source_list: { label: string; value: string }[] = [];
  if (record.agencyData) {
    record.agencyData.map((agency: any) => {
      outside_source_list.push({ label: agency.name, value: agency.id });
    });
  }
  const outside_source_selected: { label: string; value: string }[] = [];

  const fico_list: { label: string; value: string }[] = [];
  if (record.ficoriskFactorData) {
    record.ficoriskFactorData.map((fico: any) => {
      fico_list.push({ label: fico.name, value: fico.id });
    });
  }
  const fico_selected: { label: string; value: string }[] = [];
  const credit_infor_used_list: { label: string; value: string }[] = [];
  credit_infor_used_list.push({
    label: "Credit Report",
    value: "Credit Report",
  });
  credit_infor_used_list.push({ label: "Credit Score", value: "Credit Score" });
  const credit_infor_used_selected: { label: string; value: string }[] = [];

  const handleClickOutsideSource = (event: any) => {
    if (event.target.checked) {
      setOutsideSourceSelected([...outsideSourceSelected, event.target.value]);
    } else {
      setOutsideSourceSelected(
        outsideSourceSelected.filter((item) => item !== event.target.value)
      );
    }
  };

  const handleClickCreditInforUsed = (event: any) => {
    if (event.target.checked) {
      setCreditValSlected([...creditValSlected, event.target.value]);
    } else {
      setCreditValSlected(
        creditValSlected.filter((item) => item !== event.target.value)
      );
    }
  };

  React.useEffect(() => {
    if (outsideSourceSelected.length > 0) {
      var select_agency_list = outsideSourceSelected.join(",");
      if (
        select_agency_list.indexOf("1") != -1 ||
        select_agency_list.indexOf("2") != -1 ||
        select_agency_list.indexOf("3") != -1 ||
        select_agency_list.indexOf("4") != -1
      ) {
        setShowCreditBureau(true);
      } else {
        setShowCreditBureau(false);
      }
    }
  }, [outsideSourceSelected]);

  React.useEffect(() => {
    if (creditValSlected.length > 0) {
      const creditValSlectedVal = creditValSlected.join(",");
      if (creditValSlectedVal.indexOf("Credit Score") != -1) {
        setShowFico(true);
      } else {
        setShowFico(false);
      }
    }
  }, [creditValSlected]);

  return (
    <React.Fragment>
      <Button
        id="btn-application-counter"
        label="Counter"
        variant="contained"
        size="medium"
        color="warning"
        sx={{ marginLeft: "10px", width: "120px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-counter"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.comment = formJson.notes;

            let form_adverse_select: string[] = [];
            var checkboxes = document.querySelectorAll(
              '[name^="adverse_select[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_adverse_select.push(inputElement.value);
              }
            });

            let form_agency_select: string[] = [];
            checkboxes = document.querySelectorAll('[name^="agency_select[]"]');
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_agency_select.push(inputElement.value);
              }
            });

            let form_credit_infor_used_selected: string[] = [];
            checkboxes = document.querySelectorAll(
              '[name^="credit_infor_used_selected[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_credit_infor_used_selected.push(inputElement.value);
              }
            });

            let form_fico_select: string[] = [];
            checkboxes = document.querySelectorAll('[name^="fico[]"]');
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_fico_select.push(inputElement.value);
              }
            });

            formJson.adverse = form_adverse_select;
            formJson.agency = form_agency_select;
            formJson.fico = form_fico_select;
            formJson.credit_infor = form_credit_infor_used_selected;

            formJson.option = "counter";
            const reqUrl = `applications/actions/recommend/counter`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (responseBack && responseBack.status == "200") {
              successNotify("Data saved successfully");
              if (props.cb) {
                props.cb("To Notify");
              }
              handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Counter" />
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: "500px",
              minHeight: "300px",
            }}
          >
            <DialogContentText></DialogContentText>
            <DialogApplicationBaseInfo appId={appId} record={record} />
            <Grid container sx={{ mb: 2, pb: 2 }}>
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Recommended Terms
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <CheckBoxList
                  id="adverse_select"
                  name="adverse_select[]"
                  list={reasons_adverse_action_list}
                  selectedlist={reasons_adverse_action_selected}
                  title="Reasons For Adverse Action"
                />
              </Grid>

              <Grid sx={{ mb: 2 }} container>
                <CheckBoxList
                  id="agency_select"
                  name="agency_select[]"
                  list={outside_source_list}
                  selectedlist={outside_source_selected}
                  title="Outside Source Of Information"
                  handleClick={handleClickOutsideSource}
                />
              </Grid>

              {showCreditBureau && (
                <Grid sx={{ mb: 2 }} container>
                  <CheckBoxList
                    id="credit_infor_used_selected"
                    name="credit_infor_used_selected[]"
                    list={credit_infor_used_list}
                    selectedlist={credit_infor_used_selected}
                    title="Please select credit bureau information used"
                    handleClick={handleClickCreditInforUsed}
                  />
                </Grid>
              )}
              {showFico && (
                <Grid sx={{ mb: 2 }} container>
                  <CheckBoxList
                    id="fico"
                    name="fico[]"
                    list={fico_list}
                    selectedlist={fico_selected}
                    title="Fico Risk Factor"
                  />
                </Grid>
              )}
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle
                    fullWidth
                    title="Amount Offered"
                    required={true}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CustomNumberTextField
                    fullWidth
                    variant="outlined"
                    id="amount"
                    name="amount"
                    required
                    value={amountOffered}
                    onChange={(e) => {
                      setAmountOffered(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>

              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Interest Offered" required={true} />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelect
                    fullWidth={true}
                    variant="outlined"
                    id="rate"
                    name="rate"
                    optionlist={defautRateOptionList}
                    required={true}
                    className="numericText"
                    value={rateOffered}
                    onChange={(e) => {
                      setRateOffered(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Term Offered" required={true} />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelect
                    fullWidth={true}
                    variant="outlined"
                    id="term"
                    name="term"
                    optionlist={defautTermsList}
                    required={true}
                    value={termOffered}
                    onChange={(e) => {
                      setTermOffered(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>

              <Grid sx={{ mb: 2 }} container>
                <HeaderLabelTitle
                  title="Add Note (Max 150 Characters)"
                  required={true}
                />
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <TextField
                  required
                  id="notes"
                  name="notes"
                  placeholder="Notes"
                  multiline={true}
                  minRows={3}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Counter" color="warning" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
